// src/data/prayerContent.js
// Complete prayer content for all 20 factors (100 prayer points total - 5 per factor)

export const PRAYER_CONTENT = {
  // ==========================================
  // FACTOR 1: Emotional Stability & Conflict Resolution
  // ==========================================
  1: {
    factorName: "Emotional Stability & Conflict Resolution",
    foundationScripture: "He who is slow to anger is better than the mighty, and he who rules his spirit than he who takes a city. — Proverbs 16:32 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, make us emotionally mature and stable",
        prayer: "Father, help us to rule our spirits with gentleness and wisdom.",
        scripture: "Proverbs 16:32"
      },
      {
        number: 2,
        title: "We receive grace to handle anger with patience and love",
        prayer: "Lord, teach us to be quick to hear, slow to speak, and slow to anger.",
        scripture: "James 1:19–20"
      },
      {
        number: 3,
        title: "Father, let peace govern our hearts and words in conflict",
        prayer: "Let the peace of Christ rule in our hearts in every disagreement.",
        scripture: "Colossians 3:15"
      },
      {
        number: 4,
        title: "Lord, give us humility to say 'I'm sorry' and forgive easily",
        prayer: "Clothe us with kindness, humility, and patience.",
        scripture: "Colossians 3:12–13"
      },
      {
        number: 5,
        title: "We receive the Spirit of self-control in all emotions",
        prayer: "Holy Spirit, fill us with Your fruit — love, joy, peace, and self-control.",
        scripture: "Galatians 5:22–23"
      }
    ]
  },

  // ==========================================
  // FACTOR 2: Communication Style & Intimacy
  // ==========================================
  2: {
    factorName: "Communication Style & Intimacy",
    foundationScripture: "Let your speech always be with grace, seasoned with salt, that you may know how you ought to answer each one. — Colossians 4:6 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, teach us to communicate with love and grace",
        prayer: "Let our words bring life, not pain, and build each other up daily.",
        scripture: "Ephesians 4:29"
      },
      {
        number: 2,
        title: "Father, give us listening hearts that understand before reacting",
        prayer: "Help us to be quick to hear, slow to speak, and slow to anger.",
        scripture: "James 1:19"
      },
      {
        number: 3,
        title: "Holy Spirit, remove every barrier to emotional and spiritual intimacy",
        prayer: "Perfect Your love in us so that fear, pride, or shame will not divide us.",
        scripture: "1 John 4:18"
      },
      {
        number: 4,
        title: "Lord, make our conversations gentle, honest, and healing",
        prayer: "Set a guard over our mouths and guide our words with wisdom.",
        scripture: "Psalm 141:3"
      },
      {
        number: 5,
        title: "Father, renew the warmth and tenderness in our affection",
        prayer: "Let our love abound more and more in knowledge and depth of insight.",
        scripture: "Philippians 1:9"
      }
    ]
  },

  // ==========================================
  // FACTOR 3: Financial Management & Stewardship
  // ==========================================
  3: {
    factorName: "Financial Management & Stewardship",
    foundationScripture: "Moreover it is required in stewards that one be found faithful. — 1 Corinthians 4:2 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, make us faithful and wise stewards of every resource You entrust to us",
        prayer: "Teach us to manage money with integrity and purpose.",
        scripture: "Luke 16:10–11"
      },
      {
        number: 2,
        title: "Father, deliver us from financial pride, waste, and fear",
        prayer: "Help us to trust You as our Provider, not our possessions.",
        scripture: "Philippians 4:19"
      },
      {
        number: 3,
        title: "Lord, unite our hearts in financial agreement and vision",
        prayer: "Let there be oneness in our giving, saving, and spending.",
        scripture: "Amos 3:3"
      },
      {
        number: 4,
        title: "We receive grace to honor You with our tithe, generosity, and contentment",
        prayer: "Make us cheerful givers who lay up treasures in heaven.",
        scripture: "2 Corinthians 9:7, Matthew 6:20"
      },
      {
        number: 5,
        title: "Father, bless the work of our hands and give us divine ideas for increase",
        prayer: "Establish the work of our hands and open doors of provision.",
        scripture: "Deuteronomy 28:12, Psalm 90:17"
      }
    ]
  },

  // ==========================================
  // FACTOR 4: Social Compatibility & Family Dynamics
  // ==========================================
  4: {
    factorName: "Social Compatibility & Family Dynamics",
    foundationScripture: "If it is possible, as much as depends on you, live peaceably with all men. — Romans 12:18 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, teach us to live in peace and harmony with each other and our families",
        prayer: "Give us wisdom to maintain peace in every relationship.",
        scripture: "Romans 12:18"
      },
      {
        number: 2,
        title: "Father, help us to honor one another's families without losing our unity",
        prayer: "Let love and respect flow between our families through us.",
        scripture: "Ephesians 6:2–3"
      },
      {
        number: 3,
        title: "Lord, make our home a place of joy, laughter, and hospitality",
        prayer: "May our relationship radiate warmth and draw others to Your love.",
        scripture: "Hebrews 13:2"
      },
      {
        number: 4,
        title: "Father, remove every cultural or personality clash that could divide us",
        prayer: "Give us understanding hearts to embrace our differences in grace.",
        scripture: "Colossians 3:14"
      },
      {
        number: 5,
        title: "Lord, surround us with godly friends and mentors that will strengthen our marriage",
        prayer: "Let those who walk with us lead us closer to Your purpose.",
        scripture: "Proverbs 13:20"
      }
    ]
  },

  // ==========================================
  // FACTOR 5: Life Planning & Flexibility
  // ==========================================
  5: {
    factorName: "Life Planning & Flexibility",
    foundationScripture: "A man's heart plans his way, but the Lord directs his steps. — Proverbs 16:9 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, guide our dreams, goals, and future plans according to Your perfect will",
        prayer: "Direct our steps so that every plan glorifies You.",
        scripture: "Proverbs 16:9"
      },
      {
        number: 2,
        title: "Father, make us flexible and full of faith when life changes unexpectedly",
        prayer: "Help us to trust You even when plans shift or doors close.",
        scripture: "Romans 8:28"
      },
      {
        number: 3,
        title: "Lord, unite our hearts in purpose so that we move forward in agreement",
        prayer: "Let Your counsel stand in every decision we make together.",
        scripture: "Amos 3:3, Proverbs 19:21"
      },
      {
        number: 4,
        title: "Father, give us wisdom to plan diligently and the humility to yield to Your timing",
        prayer: "Teach us to number our days and apply our hearts to wisdom.",
        scripture: "Psalm 90:12"
      },
      {
        number: 5,
        title: "Lord, bless our seasons of change with peace and alignment",
        prayer: "Be the anchor in every transition and the peace in every storm.",
        scripture: "Isaiah 26:3"
      }
    ]
  },

  // ==========================================
  // FACTOR 6: Love Languages
  // ==========================================
  6: {
    factorName: "Love Languages",
    foundationScripture: "Let all that you do be done with love. — 1 Corinthians 16:14 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, teach us to express love in ways that our partner truly understands",
        prayer: "Fill our hearts with divine sensitivity and affection.",
        scripture: "Philippians 1:9"
      },
      {
        number: 2,
        title: "Father, help us to love not only in words but in actions that build connection",
        prayer: "Let our love be genuine, showing care in deeds and truth.",
        scripture: "1 John 3:18"
      },
      {
        number: 3,
        title: "Holy Spirit, remove every selfishness that hinders genuine love",
        prayer: "Help us to esteem one another above ourselves.",
        scripture: "Philippians 2:3–4"
      },
      {
        number: 4,
        title: "Lord, renew the fire of romance, kindness, and tenderness between us",
        prayer: "Restore to us the joy and warmth of true love.",
        scripture: "Song of Solomon 2:16"
      },
      {
        number: 5,
        title: "Father, make our home a reflection of Your love",
        prayer: "Let love cover all wrongs and make our hearts one.",
        scripture: "1 Peter 4:8"
      }
    ]
  },

  // ==========================================
  // FACTOR 7: Personality & Temperament
  // ==========================================
  7: {
    factorName: "Personality & Temperament",
    foundationScripture: "Having then gifts differing according to the grace that is given to us, let us use them… — Romans 12:6 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, help us understand and celebrate our different personalities",
        prayer: "Teach us to honor our differences as gifts, not conflicts.",
        scripture: "Romans 12:6"
      },
      {
        number: 2,
        title: "Father, give us grace to respond with patience when our temperaments clash",
        prayer: "Let gentleness and understanding rule our reactions.",
        scripture: "Colossians 3:12–13"
      },
      {
        number: 3,
        title: "Holy Spirit, shape our character to reflect Christ in every mood and season",
        prayer: "Conform our temperaments to the image of Your Son.",
        scripture: "Romans 8:29"
      },
      {
        number: 4,
        title: "Lord, fill our hearts with empathy to see from each other's perspective",
        prayer: "Give us the mind of Christ — humble, understanding, and tender.",
        scripture: "Philippians 2:5"
      },
      {
        number: 5,
        title: "Father, let our strengths complement and not compete with one another",
        prayer: "Make us one body with many parts, working in harmony and love.",
        scripture: "1 Corinthians 12:12"
      }
    ]
  },

  // ==========================================
  // FACTOR 8: Spiritual Compatibility & Values
  // ==========================================
  8: {
    factorName: "Spiritual Compatibility & Values",
    foundationScripture: "Do not be unequally yoked together with unbelievers. — 2 Corinthians 6:14 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, make our faith the foundation of our marriage",
        prayer: "Let Christ be the center of our home and the anchor of our love.",
        scripture: "Colossians 2:7"
      },
      {
        number: 2,
        title: "Father, unite our hearts in worship, prayer, and obedience to Your Word",
        prayer: "Help us to seek first Your kingdom in all we do.",
        scripture: "Matthew 6:33"
      },
      {
        number: 3,
        title: "Lord, remove every spiritual imbalance and draw us closer to You together",
        prayer: "Restore spiritual harmony and passion for Your presence.",
        scripture: "Psalm 42:1–2"
      },
      {
        number: 4,
        title: "Holy Spirit, guide us in living out godly values and decisions daily",
        prayer: "Let Your Word be a lamp to our feet and a light to our path.",
        scripture: "Psalm 119:105"
      },
      {
        number: 5,
        title: "Father, make our marriage a testimony of Your power, love, and grace",
        prayer: "Let others see Christ in how we live, give, and serve.",
        scripture: "Matthew 5:16"
      }
    ]
  },

  // ==========================================
  // FACTOR 9: Parenting Philosophy & Family Vision
  // ==========================================
  9: {
    factorName: "Parenting Philosophy & Family Vision",
    foundationScripture: "Train up a child in the way he should go, and when he is old he will not depart from it. — Proverbs 22:6 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, give us wisdom to raise children who love and honor You",
        prayer: "Let our parenting reflect Your heart and truth.",
        scripture: "Deuteronomy 6:6–7"
      },
      {
        number: 2,
        title: "Father, unite us in purpose and method as we nurture our family",
        prayer: "Let there be oneness in discipline, teaching, and guidance.",
        scripture: "Amos 3:3"
      },
      {
        number: 3,
        title: "Holy Spirit, help us balance correction with compassion",
        prayer: "May our words and actions lead our children toward righteousness.",
        scripture: "Ephesians 6:4"
      },
      {
        number: 4,
        title: "Lord, make our home a place of love, laughter, and faith for future generations",
        prayer: "Let our family be a house that serves You joyfully.",
        scripture: "Joshua 24:15"
      },
      {
        number: 5,
        title: "Father, give us vision for our family's future and strength to walk in it",
        prayer: "Let our descendants be mighty on the earth and faithful in all their ways.",
        scripture: "Psalm 112:1–2"
      }
    ]
  },

  // ==========================================
  // FACTOR 10: Sexual Intimacy & Expectations
  // ==========================================
  10: {
    factorName: "Sexual Intimacy & Expectations",
    foundationScripture: "Marriage is honorable among all, and the bed undefiled. — Hebrews 13:4 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, help us to honor You in our intimacy and keep our love pure",
        prayer: "Sanctify our union and make our affection a reflection of Your covenant love.",
        scripture: "Hebrews 13:4"
      },
      {
        number: 2,
        title: "Father, remove every fear, shame, or misunderstanding about intimacy",
        prayer: "Clothe us with acceptance, trust, and joy in our oneness.",
        scripture: "Genesis 2:25"
      },
      {
        number: 3,
        title: "Holy Spirit, teach us to give, not demand — to serve each other in love",
        prayer: "Let our bodies and hearts be yielded in mutual respect.",
        scripture: "1 Corinthians 7:3–4"
      },
      {
        number: 4,
        title: "Lord, restore passion and tenderness wherever it has grown cold",
        prayer: "Breathe new life and warmth into our physical and emotional connection.",
        scripture: "Song of Solomon 1:2"
      },
      {
        number: 5,
        title: "Father, protect our intimacy from every external temptation and distraction",
        prayer: "Keep our hearts and eyes single toward one another.",
        scripture: "Proverbs 5:18–19, Matthew 6:22"
      }
    ]
  },

  // ==========================================
  // FACTOR 11: Extended Family & Boundaries
  // ==========================================
  11: {
    factorName: "Extended Family & Boundaries",
    foundationScripture: "Therefore a man shall leave his father and mother and be joined to his wife. — Genesis 2:24 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, help us to build a home where loyalty to one another comes first under You",
        prayer: "Teach us to leave and cleave with wisdom and grace.",
        scripture: "Genesis 2:24"
      },
      {
        number: 2,
        title: "Father, give us favor and peace with both sides of our families",
        prayer: "Let love and respect flow across generations.",
        scripture: "Romans 12:18"
      },
      {
        number: 3,
        title: "Holy Spirit, grant us wisdom to set healthy boundaries without offense",
        prayer: "Help us to balance honor with independence.",
        scripture: "Proverbs 4:7"
      },
      {
        number: 4,
        title: "Lord, protect our marriage from division caused by external influences",
        prayer: "Be the wall of peace around our union.",
        scripture: "Nehemiah 4:9"
      },
      {
        number: 5,
        title: "Father, make us examples of unity that bring healing to our extended families",
        prayer: "Let our love be a light that mends old wounds and inspires peace.",
        scripture: "Matthew 5:9"
      }
    ]
  },

  // ==========================================
  // FACTOR 12: Career & Life Goals
  // ==========================================
  12: {
    factorName: "Career & Life Goals",
    foundationScripture: "Commit your work to the Lord, and your plans will be established. — Proverbs 16:3 (ESV)",
    points: [
      {
        number: 1,
        title: "Lord, align our career paths and life goals with Your divine purpose",
        prayer: "Let every ambition glorify You and advance Your kingdom.",
        scripture: "Proverbs 16:3"
      },
      {
        number: 2,
        title: "Father, help us support each other's dreams without competition or resentment",
        prayer: "Make us true partners in purpose, not rivals in success.",
        scripture: "Romans 12:10"
      },
      {
        number: 3,
        title: "Holy Spirit, give us discernment to know when to move, wait, or change direction",
        prayer: "Order our steps and establish the work of our hands.",
        scripture: "Psalm 90:17, Psalm 37:23"
      },
      {
        number: 4,
        title: "Lord, bless us with favor in our professions and open doors no man can shut",
        prayer: "Let our labor bring fruit that honors You.",
        scripture: "Colossians 3:23–24"
      },
      {
        number: 5,
        title: "Father, teach us to balance work, rest, family, and ministry",
        prayer: "Let our priorities reflect Your wisdom, not worldly pressure.",
        scripture: "Matthew 6:33"
      }
    ]
  },

  // ==========================================
  // FACTOR 13: Emotional Intelligence
  // ==========================================
  13: {
    factorName: "Emotional Intelligence",
    foundationScripture: "A fool vents all his feelings, but a wise man holds them back. — Proverbs 29:11 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, give us wisdom to manage our emotions with maturity and grace",
        prayer: "Help us to respond with patience and understanding, not pride or anger.",
        scripture: "Proverbs 29:11"
      },
      {
        number: 2,
        title: "Father, fill our hearts with compassion so we can sense each other's pain and joy",
        prayer: "Teach us to rejoice with those who rejoice and weep with those who weep.",
        scripture: "Romans 12:15"
      },
      {
        number: 3,
        title: "Holy Spirit, help us to speak words that heal and not wound",
        prayer: "Let our speech always be seasoned with grace.",
        scripture: "Colossians 4:6"
      },
      {
        number: 4,
        title: "Lord, heal us from emotional triggers rooted in past experiences",
        prayer: "Renew our minds and make us whole from within.",
        scripture: "Romans 12:2, Psalm 147:3"
      },
      {
        number: 5,
        title: "Father, give us the heart of Christ — humble, patient, and full of mercy",
        prayer: "Let the same mind that was in Christ Jesus dwell richly in us.",
        scripture: "Philippians 2:5"
      }
    ]
  },

  // ==========================================
  // FACTOR 14: Trust & Past Relationships
  // ==========================================
  14: {
    factorName: "Trust & Past Relationships",
    foundationScripture: "Love bears all things, believes all things, hopes all things, endures all things. — 1 Corinthians 13:7 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, build unshakable trust between us that is rooted in truth and love",
        prayer: "Let integrity and faithfulness be the pillars of our relationship.",
        scripture: "Proverbs 3:3–4"
      },
      {
        number: 2,
        title: "Father, heal every wound and insecurity from past relationships",
        prayer: "Set us free from fear, bitterness, and emotional baggage.",
        scripture: "Isaiah 43:18–19"
      },
      {
        number: 3,
        title: "Holy Spirit, help us to be transparent with one another in honesty and grace",
        prayer: "Let no deceit or pretense dwell between us.",
        scripture: "Ephesians 4:25"
      },
      {
        number: 4,
        title: "Lord, guard our hearts from jealousy, suspicion, and distrust",
        prayer: "Perfect Your love in us that casts out all fear.",
        scripture: "1 John 4:18"
      },
      {
        number: 5,
        title: "Father, teach us to forgive quickly and rebuild trust through patience",
        prayer: "Make us ministers of reconciliation and peace.",
        scripture: "2 Corinthians 5:18–19"
      }
    ]
  },

  // ==========================================
  // FACTOR 15: Sexual & Physical Boundaries
  // ==========================================
  15: {
    factorName: "Sexual & Physical Boundaries",
    foundationScripture: "Flee from sexual immorality... You were bought at a price. — 1 Corinthians 6:18–20 (NIV)",
    points: [
      {
        number: 1,
        title: "Lord, help us to honor You with our bodies and keep our relationship pure",
        prayer: "Let holiness and discipline guide our desires and actions.",
        scripture: "1 Thessalonians 4:3–4"
      },
      {
        number: 2,
        title: "Father, give us strength to resist temptation and maintain integrity",
        prayer: "Keep us from anything that defiles our covenant or weakens our witness.",
        scripture: "2 Timothy 2:22"
      },
      {
        number: 3,
        title: "Holy Spirit, renew our minds and make our thoughts pleasing to You",
        prayer: "Purify our hearts and fill us with self-control and reverence.",
        scripture: "Philippians 4:8, Galatians 5:22–23"
      },
      {
        number: 4,
        title: "Lord, teach us to express affection with honor, patience, and genuine love",
        prayer: "Let our intimacy reflect Your purity and covenant faithfulness.",
        scripture: "Hebrews 13:4"
      },
      {
        number: 5,
        title: "Father, protect our marriage from sexual sin, secrecy, or emotional infidelity",
        prayer: "Let the fear of the Lord guard our hearts and keep our union undefiled.",
        scripture: "Proverbs 5:18–19, Psalm 19:14"
      }
    ]
  },

  // ==========================================
  // FACTOR 16: Spiritual Maturity & Shared Faith
  // ==========================================
  16: {
    factorName: "Spiritual Maturity & Shared Faith",
    foundationScripture: "But grow in the grace and knowledge of our Lord and Savior Jesus Christ. — 2 Peter 3:18 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, deepen our roots in Your Word and strengthen our walk with You daily",
        prayer: "Let our marriage grow through consistent prayer and obedience.",
        scripture: "Colossians 2:6–7"
      },
      {
        number: 2,
        title: "Father, give us unity in faith, devotion, and pursuit of Your will",
        prayer: "Make us one in spirit, serving You with one heart.",
        scripture: "Philippians 1:27"
      },
      {
        number: 3,
        title: "Holy Spirit, help us to lead one another closer to Christ",
        prayer: "Let our influence in each other's lives always draw us to righteousness.",
        scripture: "Hebrews 10:24–25"
      },
      {
        number: 4,
        title: "Lord, deliver us from spiritual laziness and rekindle our passion for Your presence",
        prayer: "Let our home become a sanctuary of worship, prayer, and peace.",
        scripture: "Joshua 24:15, Psalm 84:2"
      },
      {
        number: 5,
        title: "Father, use our union as a vessel for Your glory and a light to other couples",
        prayer: "Let our testimony inspire others to grow in faith and love.",
        scripture: "Matthew 5:16"
      }
    ]
  },

  // ==========================================
  // FACTOR 17: Decision-Making & Leadership Dynamics
  // ==========================================
  17: {
    factorName: "Decision-Making & Leadership Dynamics",
    foundationScripture: "Submit to one another out of reverence for Christ. — Ephesians 5:21 (NIV)",
    points: [
      {
        number: 1,
        title: "Lord, teach us to submit to one another in love and humility",
        prayer: "Let mutual respect guide every decision we make.",
        scripture: "Ephesians 5:21"
      },
      {
        number: 2,
        title: "Father, give us wisdom to lead and follow in the right seasons",
        prayer: "Help us recognize when to step forward and when to step back.",
        scripture: "Proverbs 15:22"
      },
      {
        number: 3,
        title: "Holy Spirit, unite our hearts when we face difficult decisions",
        prayer: "Let Your peace be the tiebreaker in every disagreement.",
        scripture: "Colossians 3:15"
      },
      {
        number: 4,
        title: "Lord, remove pride and control from our decision-making",
        prayer: "Make us humble servants who seek Your will above our own.",
        scripture: "Philippians 2:3–4"
      },
      {
        number: 5,
        title: "Father, let Christ be the head of our home and marriage",
        prayer: "May all our decisions honor You and reflect Your kingdom.",
        scripture: "Colossians 1:18"
      }
    ]
  },

  // ==========================================
  // FACTOR 18: Forgiveness, Grace & Healing
  // ==========================================
  18: {
    factorName: "Forgiveness, Grace & Healing",
    foundationScripture: "Be kind and compassionate to one another, forgiving each other. — Ephesians 4:32 (NIV)",
    points: [
      {
        number: 1,
        title: "Lord, give us hearts that forgive quickly and completely",
        prayer: "Help us to release every offense and extend grace freely.",
        scripture: "Ephesians 4:32"
      },
      {
        number: 2,
        title: "Father, heal every wound and restore what has been broken",
        prayer: "Let Your love mend our hearts and renew our hope.",
        scripture: "Psalm 147:3"
      },
      {
        number: 3,
        title: "Holy Spirit, teach us to love as You have loved us",
        prayer: "Let mercy triumph over judgment in our marriage.",
        scripture: "James 2:13"
      },
      {
        number: 4,
        title: "Lord, remove bitterness, resentment, and unforgiveness from our hearts",
        prayer: "Replace hurt with healing and anger with peace.",
        scripture: "Hebrews 12:15"
      },
      {
        number: 5,
        title: "Father, make us ambassadors of reconciliation in our home",
        prayer: "Let forgiveness be the language we speak daily.",
        scripture: "2 Corinthians 5:18"
      }
    ]
  },

  // ==========================================
  // FACTOR 19: Purpose, Calling & Kingdom Partnership
  // ==========================================
  19: {
    factorName: "Purpose, Calling & Kingdom Partnership",
    foundationScripture: "For we are God's handiwork, created in Christ Jesus to do good works. — Ephesians 2:10 (NIV)",
    points: [
      {
        number: 1,
        title: "Lord, reveal Your purpose for our marriage",
        prayer: "Show us the kingdom work You've called us to do together.",
        scripture: "Ephesians 2:10"
      },
      {
        number: 2,
        title: "Father, unite us in mission and vision for Your glory",
        prayer: "Let our marriage be a partnership that advances Your kingdom.",
        scripture: "Matthew 28:19–20"
      },
      {
        number: 3,
        title: "Holy Spirit, empower us to fulfill our calling with boldness",
        prayer: "Give us courage to step into the assignment You've given us.",
        scripture: "Acts 1:8"
      },
      {
        number: 4,
        title: "Lord, help us to prioritize Your kingdom above our comfort",
        prayer: "Make us willing vessels for Your purposes.",
        scripture: "Matthew 6:33"
      },
      {
        number: 5,
        title: "Father, let our marriage leave a legacy that honors You",
        prayer: "May future generations be blessed by our faithfulness.",
        scripture: "Psalm 112:1–2"
      }
    ]
  },

  // ==========================================
  // FACTOR 20: Technology & Social Media Boundaries
  // ==========================================
  20: {
    factorName: "Technology & Social Media Boundaries",
    foundationScripture: "All things are lawful for me, but not all things are helpful. — 1 Corinthians 10:23 (NKJV)",
    points: [
      {
        number: 1,
        title: "Lord, help us use technology wisely and with self-control",
        prayer: "Let our devices serve us, not control us.",
        scripture: "1 Corinthians 10:23"
      },
      {
        number: 2,
        title: "Father, protect our marriage from digital distractions and temptations",
        prayer: "Keep our eyes and hearts focused on each other and You.",
        scripture: "Proverbs 4:23"
      },
      {
        number: 3,
        title: "Holy Spirit, convict us when technology becomes an idol",
        prayer: "Help us to prioritize real connection over virtual presence.",
        scripture: "Galatians 5:16"
      },
      {
        number: 4,
        title: "Lord, give us wisdom to set healthy boundaries with social media",
        prayer: "Protect us from comparison, pride, and the fear of man.",
        scripture: "Proverbs 29:25"
      },
      {
        number: 5,
        title: "Father, make our online presence honor You and our marriage",
        prayer: "Let our digital footprint reflect Your light and love.",
        scripture: "Matthew 5:16"
      }
    ]
  }
};

export default PRAYER_CONTENT;